module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "trip"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('BUSTRIPS')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-row', {
    ref: "filter",
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.tab = (_vm.tab == 1 ? 0 : 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.tab === 0 ? 'fa-list' : 'fa-map-marker']
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tab === 0 ? _vm.$t('LIST') : _vm.$t('MAP'))
    }
  })])], 1), _vm._v(" "), (_vm.tab === 0) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(_vm.active_trips() != 0) ? _c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SELECTROUTE')
    },
    on: {
      "change": _vm.routeChange
    },
    model: {
      value: (_vm.route),
      callback: function($$v) {
        _vm.route = $$v
      },
      expression: "route"
    }
  }, [_c('el-option', {
    staticClass: "route-select",
    attrs: {
      "value": -1
    }
  }, [_c('el-tag', {
    staticStyle: {
      "display": "block",
      "text-align": "center"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.selectAll() ? _vm.$t('UNCHECKALL') : _vm.$t('CHECKALL')))])], 1), _vm._v(" "), _vm._l((_vm.routes), function(item, key) {
    return (_vm.isLive(item)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item.TourName,
        "value": key
      }
    }, [_c('el-tag', {
      staticStyle: {
        "display": "block",
        "text-align": "center"
      },
      style: ('background-color:' + item.RouteColor)
    }, [_vm._v("\n              " + _vm._s(item.TourName) + "\n              "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.paths[item.TourID] != undefined),
        expression: "paths[item.TourID] !=undefined"
      }],
      staticClass: "fa fa-check"
    })])])], 1) : _vm._e()
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live && _vm.active_filter == 'direction') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYDIRECTION'),
      "clearable": ""
    },
    on: {
      "change": _vm.getFilteredTrips
    },
    model: {
      value: (_vm.Direction),
      callback: function($$v) {
        _vm.Direction = $$v
      },
      expression: "Direction"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": _vm.$t('HOMETOSCHOOL')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": _vm.$t('SCHOOLTOHOME')
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live && _vm.active_filter == 'monitor') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYMONITOR'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getFilteredTrips
    },
    model: {
      value: (_vm.BusMonitorID),
      callback: function($$v) {
        _vm.BusMonitorID = $$v
      },
      expression: "BusMonitorID"
    }
  }, _vm._l((_vm.monitors), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.FirstName_EN + ' ' + item.LastName_EN,
        "value": item.BusMonitorID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 1 && !_vm.is_live && _vm.active_filter == 'date') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE'),
      "picker-options": _vm.pickerOption,
      "clearabble": _vm.checkToday()
    },
    on: {
      "change": function($event) {
        _vm.getFilteredTrips('date')
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "live-trip-btn",
    attrs: {
      "span": 6
    }
  }, [(_vm.tab === 1) ? _c('el-badge', {
    attrs: {
      "value": _vm.active_trips()
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": !_vm.is_live ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        _vm.btnGroup(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSEDTRIPS')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.is_live ? 'primary' : 'default'
    },
    on: {
      "click": function($event) {
        _vm.btnGroup(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LIVETRIPS')))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 0),
      expression: "tab==0"
    }],
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: _vm.mapHeight + 'px'
    }),
    attrs: {
      "id": "live-gmap"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 1),
      expression: "tab==1"
    }],
    staticStyle: {
      "border-top": "1px solid #ddd"
    },
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, [_c('el-row', {
    staticStyle: {
      "height": "inherit"
    },
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "twocolumn",
    attrs: {
      "span": 12
    }
  }, [(_vm.listTrips['left'].length == 0) ? _c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v(_vm._s(_vm.$t('NOANYWARNTRIPS')))])]) : _vm._e(), _vm._v(" "), _c('VuePerfectScrollbar', {
    ref: "ScrollbarLeft",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, [_c('div', _vm._l((_vm.listTrips['left']), function(trip, key) {
    return (_vm.is_live == !trip.IsClosed) ? _c('el-button', {
      key: key,
      staticClass: "trip-box",
      attrs: {
        "disabled": trip.disabledTrip,
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.goTo(trip.TripID)
        }
      }
    }, [(_vm.cachedDates['left'][trip.Date] == trip.TripID) ? _c('el-row', {
      staticClass: "row date-header"
    }, [_c('i', {
      staticClass: "el-icon-date"
    }), _vm._v(" " + _vm._s(_vm.tripDate(trip.Db_Date)))]) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      staticClass: "busTag",
      attrs: {
        "span": 2
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(trip.busNumber) + " ")])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "activity",
      attrs: {
        "span": 5,
        "align": _vm.alignDirection('right')
      },
      nativeOn: {
        "mouseover": function($event) {
          trip.disabledTrip = true
        },
        "mouseleave": function($event) {
          trip.disabledTrip = false
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "trip",
        "trigger": "hover",
        "disabled": trip.activity.total_alerts == 0,
        "title": _vm.$t('TRIPALERTS'),
        "placement": "right-start",
        "width": "620"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_alerts,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-bell",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.alerts),
        "default-sort": {
          prop: 'Sent',
          order: 'descending'
        },
        "empty-text": _vm.$t('NOALERTS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "85",
        "label": _vm.$t('TYPE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.Event)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "130",
        "label": _vm.$t('OCCURED')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.EventType)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "195",
        "property": "Sent",
        "label": _vm.$t('DATE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Sent)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "show-overflow-tooltip": "",
        "label": _vm.$t('MESSAGE')
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.Text ? scope.row.Text : '-'))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.EntityID != null || scope.row.Event == 'INCIDENT') ? _c('el-button', {
            attrs: {
              "size": "mini",
              "loading": scope.row.EventID === _vm.sendingEvent
            },
            on: {
              "click": function($event) {
                _vm.activityInfo(scope.row, scope.$index)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('MOREINFO')))]) : _vm._e()]
        }
      }])
    })], 1)], 1), _vm._v(" "), _c('el-popover', {
      attrs: {
        "trigger": "hover",
        "disabled": trip.activity.total_violations == 0,
        "title": _vm.$t('TRIPVIOLATIONS'),
        "placement": "right",
        "width": "450"
      }
    }, [_c('el-badge', {
      attrs: {
        "slot": "reference",
        "value": trip.activity.total_violations,
        "max": 6
      },
      slot: "reference"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-tachometer"
    })])], 1), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.arrayOfAlerts(trip.activity.violations),
        "empty-text": _vm.$t('NOVIOLATIONS'),
        "stripe": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "Type",
        "min-width": "115"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(_vm.$t(scope.row.incident_type)))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": "185",
        "label": "Date"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            attrs: {
              "name": "time"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "5px"
            }
          }, [_vm._v(_vm._s(_vm.activity_time(scope.row.Timestamp)))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "145",
        "show-overflow-tooltip": "",
        "property": "Text",
        "label": "Message"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11,
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-road fa-2x"
    }), _vm._v(" " + _vm._s(trip.TourName))]), _vm._v(" "), _c('el-col', {
      staticClass: "boardingTag",
      attrs: {
        "span": 6
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.Boarding)
      }
    })]), _vm._v(" "), (trip.IsClosed != 1) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(_vm.nextStop(trip)))]) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.CompletedIn)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MINUTES')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": _vm.$t('STARTEDAT') + ' ' + _vm.tripTime(trip.timestamp),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction == 1 ? 'fa-home' : 'fa-university']
    })])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "el-progress el-progress--line el-progress--without-text",
      class: [trip.Db_Date === null ? 'is-exception' : 'is-success']
    }, [_c('div', {
      staticClass: "el-progress-bar"
    }, [_c('div', {
      staticClass: "el-progress-bar__outer",
      staticStyle: {
        "height": "18px"
      }
    }, [(trip.IsClosed != 1) ? _c('div', {
      staticClass: "el-progress-bar__inner",
      style: ({
        width: _vm.progressWidth(trip) + '%'
      })
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed != 1) ? _c('i', {
      staticClass: "fa fa-circle",
      style: (_vm.ballDirection(trip))
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('TRIPCLOSED')))]) : _vm._e(), _vm._v(" "), (trip.Db_Date === null) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('EXPECTEDTOSTART')) + " "), _c('span', {
      staticClass: "delayed pull-right"
    }, [_vm._v(_vm._s(_vm.$t('DELAYEDBY') + ' ' + _vm.delayed_time(trip)))])]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "disabled": trip.Db_Date == null,
        "effect": "light",
        "content": trip.IsClosed == 1 ? (_vm.$t('CLOSEDAT') + ' ' + _vm.tripTime(trip.UpdatedAt)) : _vm.$t('NOTCLOSINGYET'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction != 1 ? 'fa-home' : 'fa-university']
    })])], 1)], 1), _vm._v(" "), (_vm.showCost(trip)) ? _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('IDLECOST') + ' ' + trip.IdleCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('TOTALCOST') + ' ' + trip.TotalCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  }))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "twocolumn",
    attrs: {
      "span": 12
    }
  }, [(_vm.listTrips['right'].length == 0) ? _c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v(_vm._s(_vm.$t('NOANYCLEANTRIPS')))])]) : _vm._e(), _vm._v(" "), _c('VuePerfectScrollbar', {
    ref: "ScrollbarRight",
    style: ({
      height: _vm.listHeight + 'px'
    })
  }, [_c('div', _vm._l((_vm.listTrips['right']), function(trip, key) {
    return (_vm.is_live == !trip.IsClosed) ? _c('el-button', {
      key: key,
      staticClass: "trip-box",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.goTo(trip.TripID)
        }
      }
    }, [(_vm.cachedDates['right'][trip.Date] == trip.TripID) ? _c('el-row', {
      staticClass: "row date-header"
    }, [_c('i', {
      staticClass: "el-icon-date"
    }), _vm._v(" " + _vm._s(_vm.tripDate(trip.Db_Date)))]) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      staticClass: "busTag",
      attrs: {
        "span": 4
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-bus"
    }), _vm._v(" " + _vm._s(trip.busNumber) + " ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 14,
        "align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-road fa-2x"
    }), _vm._v(" " + _vm._s(trip.TourName))]), _vm._v(" "), _c('el-col', {
      staticClass: "boardingTag",
      attrs: {
        "span": 6
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.Boarding)
      }
    })]), _vm._v(" "), (trip.IsClosed != 1) ? _c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(_vm.nextStop(trip)))]) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" "), _c('b', {
      domProps: {
        "textContent": _vm._s(trip.CompletedIn)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MINUTES')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": _vm.$t('STARTEDAT') + ' ' + _vm.tripTime(trip.timestamp),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction == 1 ? 'fa-home' : 'fa-university']
    })])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "el-progress el-progress--line el-progress--without-text",
      class: [trip.Db_Date === null ? 'is-exception' : 'is-success']
    }, [_c('div', {
      staticClass: "el-progress-bar"
    }, [_c('div', {
      staticClass: "el-progress-bar__outer",
      staticStyle: {
        "height": "18px"
      }
    }, [(trip.IsClosed != 1) ? _c('div', {
      staticClass: "el-progress-bar__inner",
      style: ({
        width: _vm.progressWidth(trip) + '%'
      })
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed != 1) ? _c('i', {
      staticClass: "fa fa-circle",
      style: (_vm.ballDirection(trip))
    }) : _vm._e(), _vm._v(" "), (trip.IsClosed == 1) ? _c('div', {
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('TRIPCLOSED')))]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2,
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": trip.IsClosed == 1 ? (_vm.$t('CLOSEDAT') + ' ' + _vm.tripTime(trip.UpdatedAt)) : _vm.$t('NOTCLOSINGYET'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: [trip.Direction != 1 ? 'fa-home' : 'fa-university']
    })])], 1)], 1), _vm._v(" "), (_vm.showCost(trip)) ? _c('el-row', {
      staticStyle: {
        "padding": "0 10px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('IDLECOST') + ' ' + trip.IdleCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": _vm.$t('TOTALCOST') + ' ' + trip.TotalCost + ' ' + _vm.$t('AED'),
        "position": "bottom"
      }
    }, [_c('el-tag', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" " + _vm._s(trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  }))])], 1)], 1)], 1), _vm._v(" "), (_vm.tab == 1 && _vm.paginationHeight != 0) ? _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px",
      "border-top": "1px solid #ddd"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalTrips
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "incident": _vm.event,
      "alert": _vm.notifyAlert,
      "visible": _vm.eventVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.eventVisible = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30f843d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Trip.vue
// module id = 592
// module chunks = 1